import { render } from "./ButtonsField.vue?vue&type=template&id=2e154575"
import script from "./ButtonsField.vue?vue&type=script&lang=js"
export * from "./ButtonsField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ButtonsField.vue"]])

export default __exports__